import React from "react";
import { CircularProgress, Paper, TableRow, TableContainer, TableHead, TableCell, TableBody, Table, makeStyles } from "@material-ui/core";
import { Waypoint } from "react-waypoint";
import ItemDataQualityTableRow from "./ItemDataQualityTableRow";
import { BeaconItemDataQualityReport } from "../../../api/graphQL/queryModels";

const useStyles = makeStyles((theme) => ({
    root: { width: "100%", overflow: "hidden" },
    tableContainer: { minHeight: 600, height: "calc(100vh - 200px)" },
    tableHeader: {
        "& > tr > th": { backgroundColor: theme.palette.background.paper }
    },
    centered: {
        textAlign: "center"
    },
    left: {
        textAlign: "left"
    },
    right: {
        textAlign: "right"
    }
}));

const ItemsDataQualityTable: React.FunctionComponent<{
    reports: BeaconItemDataQualityReport[];
    loading: boolean;
    hasMore: boolean;
    fetchMore: () => void;
}> = (props) => {
    const classes = useStyles();

    const { loading, hasMore, reports, fetchMore } = props;
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.tableContainer}>
                <Table stickyHeader>
                    <TableHead className={classes.tableHeader}>
                        <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell className={classes.left}>Author</TableCell>
                            <TableCell className={classes.left}>Score</TableCell>
                            <TableCell className={classes.centered}>Name</TableCell>
                            <TableCell className={classes.centered}>Preview</TableCell>
                            <TableCell className={classes.centered}>Description</TableCell>
                            <TableCell className={classes.centered}>Category</TableCell>
                            <TableCell className={classes.centered}>Tags</TableCell>
                            <TableCell className={classes.centered}>Resume Group</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading &&
                            [1, 2, 3, 4, 5, 6, 7].map((i) => {
                                return <ItemDataQualityTableRow key={i} />;
                            })}
                        {!loading &&
                            reports.map((report, i) => {
                                return <ItemDataQualityTableRow key={`${report.beaconItem.id}-${i}`} report={report} />;
                            })}
                        {!loading && hasMore && (
                            <TableRow>
                                <TableCell />
                                <TableCell />
                                <TableCell>
                                    <CircularProgress />
                                    <Waypoint onEnter={fetchMore} />
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default ItemsDataQualityTable;
